import React from 'react'
import PropTypes from 'prop-types'
import { Badge } from 'reactstrap'
import StringUtil from 'utils/string-util'
import { BANK_TRANSACTION_CATEGORIES } from 'domains/bank-transaction'

const propTypes = {
  category: PropTypes.string
}

const colorMap = {
  [BANK_TRANSACTION_CATEGORIES.ORDER_VIRTUAL_ACCOUNT_BCA]     : 'primary',
  [BANK_TRANSACTION_CATEGORIES.ORDER_VIRTUAL_ACCOUNT_NON_BCA] : 'primary',
  [BANK_TRANSACTION_CATEGORIES.ORDER_CREDIT_CARD_BCA]         : 'primary',
  [BANK_TRANSACTION_CATEGORIES.ORDER_CREDIT_CARD_BNI]         : 'primary',
  [BANK_TRANSACTION_CATEGORIES.ORDER_CREDIT_CARD_BRI]         : 'primary',
  [BANK_TRANSACTION_CATEGORIES.ORDER_CREDIT_CARD_MANDIRI]     : 'primary',
  [BANK_TRANSACTION_CATEGORIES.ORDER_CREDIT_CARD_INSTALLMENT] : 'primary',
  [BANK_TRANSACTION_CATEGORIES.ORDER_KREDIVO]                 : 'primary',
  [BANK_TRANSACTION_CATEGORIES.ORDER_GOPAY]                   : 'primary',
  [BANK_TRANSACTION_CATEGORIES.ORDER_MANUAL_BANK_TRANSFER]    : 'primary',
  [BANK_TRANSACTION_CATEGORIES.SHIPMENT_CHARGE]               : 'info',
  [BANK_TRANSACTION_CATEGORIES.REFUND]                        : 'info',
  [BANK_TRANSACTION_CATEGORIES.INBOUND_CHARGE]                : 'info',
  [BANK_TRANSACTION_CATEGORIES.ADMIN_FEE]                     : 'success',
  [BANK_TRANSACTION_CATEGORIES.PAYMENT_CHARGE]                : 'success',
  [BANK_TRANSACTION_CATEGORIES.UNKNOWN]                       : 'warning'
}

/**
 * Display ::Finances::BankTransaction.category in Badge
 * @param {string} category
 */
const BankTransactionCategoryBadge = ({ category }) => {
  const color = colorMap[category] || 'default'

  return (
    <Badge
      className='badge-lg'
      color={ color }
      pill
    >
      { StringUtil.humanizeUpperCase(category) }
    </Badge>
  )
}

BankTransactionCategoryBadge.propTypes = propTypes

export default BankTransactionCategoryBadge